"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signCVote = void 0;
const errors_1 = require("../errors");
const internal_1 = require("../types/internal");
const utils_1 = require("../utils");
const serialize_1 = require("../utils/serialize");
const getVersion_1 = require("./getVersion");
const send = (params) => (Object.assign({ ins: 35 }, params));
function* signCVote(version, cVote) {
    if (!(0, getVersion_1.getCompatibility)(version).supportsCIP36Vote) {
        throw new errors_1.DeviceVersionUnsupported(`CIP36 voting not supported by Ledger app version ${(0, utils_1.getVersionString)(version)}.`);
    }
    const MAX_VOTECAST_CHUNK_SIZE = 240;
    const votecastBytes = (0, serialize_1.hex_to_buf)(cVote.voteCastDataHex);
    let start = 0;
    let end = Math.min(votecastBytes.length, start + MAX_VOTECAST_CHUNK_SIZE);
    const initDataBuffer = Buffer.concat([
        (0, serialize_1.uint32_to_buf)(votecastBytes.length),
        votecastBytes.slice(start, end),
    ]);
    yield send({
        p1: 1,
        p2: 0,
        data: initDataBuffer,
        expectedResponseLength: 0,
    });
    start = end;
    while (start < votecastBytes.length) {
        end = Math.min(votecastBytes.length, start + MAX_VOTECAST_CHUNK_SIZE);
        yield send({
            p1: 2,
            p2: 0,
            data: votecastBytes.slice(start, end),
            expectedResponseLength: 0,
        });
        start = end;
    }
    const VOTECAST_HASH_LENGTH = 32;
    const confirmResponse = yield send({
        p1: 3,
        p2: 0,
        data: Buffer.concat([]),
        expectedResponseLength: VOTECAST_HASH_LENGTH,
    });
    const witnessResponse = yield send({
        p1: 4,
        p2: 0,
        data: (0, serialize_1.path_to_buf)(cVote.witnessPath),
        expectedResponseLength: internal_1.ED25519_SIGNATURE_LENGTH,
    });
    return {
        dataHashHex: confirmResponse.toString('hex'),
        witnessPath: cVote.witnessPath,
        witnessSignatureHex: witnessResponse.toString('hex'),
    };
}
exports.signCVote = signCVote;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2lnbkNWb3RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ludGVyYWN0aW9ucy9zaWduQ1ZvdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsc0NBQWtEO0FBRWxELGdEQUEwRDtBQUUxRCxvQ0FBeUM7QUFDekMsa0RBQXlFO0FBR3pFLDZDQUE2QztBQUU3QyxNQUFNLElBQUksR0FBRyxDQUFDLE1BS2IsRUFBYyxFQUFFLENBQUMsaUJBQUUsR0FBRyxRQUEwQixNQUFNLEVBQUUsQ0FBQTtBQUV6RCxRQUFlLENBQUMsQ0FBQyxTQUFTLENBQ3hCLE9BQWdCLEVBQ2hCLEtBQWtCO0lBRWxCLElBQUksQ0FBQyxJQUFBLDZCQUFnQixFQUFDLE9BQU8sQ0FBQyxDQUFDLGlCQUFpQixFQUFFO1FBQ2hELE1BQU0sSUFBSSxpQ0FBd0IsQ0FDaEMsb0RBQW9ELElBQUEsd0JBQWdCLEVBQ2xFLE9BQU8sQ0FDUixHQUFHLENBQ0wsQ0FBQTtLQUNGO0lBV0QsTUFBTSx1QkFBdUIsR0FBRyxHQUFHLENBQUE7SUFFbkMsTUFBTSxhQUFhLEdBQUcsSUFBQSxzQkFBVSxFQUFDLEtBQUssQ0FBQyxlQUFlLENBQUMsQ0FBQTtJQUN2RCxJQUFJLEtBQUssR0FBRyxDQUFDLENBQUE7SUFDYixJQUFJLEdBQUcsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQyxNQUFNLEVBQUUsS0FBSyxHQUFHLHVCQUF1QixDQUFDLENBQUE7SUFHekUsTUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQztRQUNuQyxJQUFBLHlCQUFhLEVBQUMsYUFBYSxDQUFDLE1BQWtCLENBQUM7UUFDL0MsYUFBYSxDQUFDLEtBQUssQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDO0tBQ2hDLENBQUMsQ0FBQTtJQUNGLE1BQU0sSUFBSSxDQUFDO1FBQ1QsRUFBRSxHQUFlO1FBQ2pCLEVBQUUsR0FBVztRQUNiLElBQUksRUFBRSxjQUFjO1FBQ3BCLHNCQUFzQixFQUFFLENBQUM7S0FDMUIsQ0FBQyxDQUFBO0lBQ0YsS0FBSyxHQUFHLEdBQUcsQ0FBQTtJQUdYLE9BQU8sS0FBSyxHQUFHLGFBQWEsQ0FBQyxNQUFNLEVBQUU7UUFDbkMsR0FBRyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsYUFBYSxDQUFDLE1BQU0sRUFBRSxLQUFLLEdBQUcsdUJBQXVCLENBQUMsQ0FBQTtRQUVyRSxNQUFNLElBQUksQ0FBQztZQUNULEVBQUUsR0FBZ0I7WUFDbEIsRUFBRSxHQUFXO1lBQ2IsSUFBSSxFQUFFLGFBQWEsQ0FBQyxLQUFLLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQztZQUNyQyxzQkFBc0IsRUFBRSxDQUFDO1NBQzFCLENBQUMsQ0FBQTtRQUNGLEtBQUssR0FBRyxHQUFHLENBQUE7S0FDWjtJQUdELE1BQU0sb0JBQW9CLEdBQUcsRUFBRSxDQUFBO0lBQy9CLE1BQU0sZUFBZSxHQUFHLE1BQU0sSUFBSSxDQUFDO1FBQ2pDLEVBQUUsR0FBa0I7UUFDcEIsRUFBRSxHQUFXO1FBQ2IsSUFBSSxFQUFFLE1BQU0sQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDO1FBQ3ZCLHNCQUFzQixFQUFFLG9CQUFvQjtLQUM3QyxDQUFDLENBQUE7SUFHRixNQUFNLGVBQWUsR0FBRyxNQUFNLElBQUksQ0FBQztRQUNqQyxFQUFFLEdBQWtCO1FBQ3BCLEVBQUUsR0FBVztRQUNiLElBQUksRUFBRSxJQUFBLHVCQUFXLEVBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQztRQUNwQyxzQkFBc0IsRUFBRSxtQ0FBd0I7S0FDakQsQ0FBQyxDQUFBO0lBRUYsT0FBTztRQUNMLFdBQVcsRUFBRSxlQUFlLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQztRQUM1QyxXQUFXLEVBQUUsS0FBSyxDQUFDLFdBQVc7UUFDOUIsbUJBQW1CLEVBQUUsZUFBZSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUM7S0FDckQsQ0FBQTtBQUNILENBQUM7QUEzRUQsOEJBMkVDIn0=